import type { FaireProductEntity } from "../../entity_types/product";

export const p_6f8kbpwmgj: FaireProductEntity = {
  token: "p_6f8kbpwmgj",
  type: "product",
  name: "Spicy Bacon Jam",
  brandToken: "b_2jx35qq7q6",
  brandName: "Midwest Fresh",
  imageUrl:
    "https://cdn.faire.com/fastly/ff85fa7bff7e0238ef16ee243a4376fa35c57cd19ba109d24fde9faad8775e44.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/59cfd53989958a81b5215538a88626e55d39683db02457f4ad6c3d70c700d302.jpeg",
    "https://cdn.faire.com/fastly/6a44f673e8e78cc796206a72219b03a27e1f27ff80925862c235bcca9338dcc5.jpeg",
    "https://cdn.faire.com/fastly/feb0e833e6d182b6c64005290fc3d3790b4df7b2a89d8e83489359865aa03b6b.jpeg",
    "https://cdn.faire.com/fastly/c61dc3c5552f37c2431ad013ea7051ee904eb64be7df301d76fa8a02512f6f48.jpeg",
    "https://cdn.faire.com/fastly/57688fac57ae842852efea3e7aad1c99171e613e8209aa0b7bca4fae3eb57e81.jpeg",
    "https://cdn.faire.com/fastly/99e6610fb99e59c43ca84032bbd97a6630afb7c6e2980235dbcf98b7ec18b820.jpeg",
    "https://cdn.faire.com/fastly/2bcd10a3b349ee9eb9e7a92112e5827221c01bb72baf5c76c35a844d53badbf4.jpeg",
    "https://cdn.faire.com/fastly/7a0e893a5cbf0a20634e5221de7030c7b8116fbd171ef4962e7e397eb5b7b06c.png",
  ],
  priceDollars: 7.1,
  description:
    "Award winning Best Burger Sauce. Originally created for a restaurant hamburger topping, this one is kicked up with habanero powder. Bacon Jam has grown into the headliner for Midwest Fresh. A gooey bacon and onion marmalade/relish, that has more uses than we know about.\n\n• Think off the grill.\n• Bratwurst, cheese burgers, grilled fish, sauteed vegetables, easy to make into a crust or topping, and great as a dip.\n\nThis is the best burger sauce in the USA. Also used for Bloody Mary’s and recently renowned for use on Charcutterie boards. Will be the spotlight at any gathering or grill party.\n\n• 2019 LUX Life Best Burger Sauce\n• 2019 LUX Life Leading Artisan Purveyor\n• 2020 GOOD FOOD Awards Finalist",
  tags: [],
  msrpDollars: 11.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:10.213Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
